export default __webpack_public_path__ + "static/media/limit_55.4a9e481d.svg";